import { render, staticRenderFns } from "./SongLinks.vue?vue&type=template&id=897724aa&"
import script from "./SongLinks.vue?vue&type=script&lang=js&"
export * from "./SongLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports